import './NavHeaders.css';
import logo from '../../img/markopedia-logo.svg';
import SearchBar from '../../components/SearchBar/SearchBar';
import SellButton from '../SellButton/SellButton';
import ProfilePicture from '../ProfilePicture/ProfilePicture';
import {Link} from 'react-router-dom';

const NavHeaders = () => {

    const isLoggedIn = localStorage.getItem("sessionId")

    return(
        <div className="nav-header">
                <Link to="/">
                    <img src={logo}></img>
                </Link>
                <SearchBar/>
                <SellButton isLoggedIn={isLoggedIn}/>
                <ProfilePicture/>
        </div>
    )
};

export default NavHeaders;